import logo from "./forevergrace-logo.png";
import "./App.css";
import image from "./forevergrace.jpg";
import { FaInstagramSquare , FaFacebookSquare  } from "react-icons/fa";
import React from "react";


function App() { 
  return (
    <div
      className="relative h-screen w-full flex items-center justify-center bg-cover bg-center text-center px-5"
      style={{
        backgroundImage: `url(${image})`,
      }}    >
      {/* Overlay */}
      <div className="absolute top-0 right-0 bottom-0 left-0 bg-[#1D2856] opacity-45"></div>

      <div className="z-50 flex flex-col justify-center text-white w-full h-screen">
        <div className="w-full justify-center flex items-center">
          <img src={logo} alt="Skin Dulge" className="w-60 h-auto py-6" />
        </div>
        <h1 className="mt-7 text-2xl md:text-4xl max-w-3xl mx-auto leading-snug">
        Site is under maintenance
        </h1>
        <p> We're working hard to improve the user experience. Stay tuned!</p>
        <div className="mt-6 flex text-white mx-auto gap-2 items-center">         
          <a href="https://www.instagram.com/forever_grace.store?igsh=cG95enlyeTVmdjV0" >
          <FaInstagramSquare className="text-white w-6 h-6"/>
          </a>
          <a href="https://www.facebook.com/share/1Y4s8THyNu/">
          <FaFacebookSquare className="text-white w-6 h-6"/>
          </a>        
      
        </div>
      </div>
    </div>
  );
}

export default App;
